import { render, staticRenderFns } from "./QuestionListItemAction.vue?vue&type=template&id=9cb07626&scoped=true&"
import script from "./QuestionListItemAction.vue?vue&type=script&lang=ts&"
export * from "./QuestionListItemAction.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionListItemAction.vue?vue&type=style&index=0&id=9cb07626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb07626",
  null
  
)

export default component.exports